import './App.css';
import React, {useContext} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginComponent from "./components/LoginComponent";
import {Outlet} from "react-router-dom";
import {AuthContext} from "./auth/AuthContext";
import AnalyticProfileProvider from './contexts/AnalyticProfileContext';
import {NotebooksProvider} from './contexts/NotebooksContext';
import PodcastsProvider from './contexts/PodcastsContext';

const App = () => {
  const {isAuthenticated} = useContext(AuthContext);
  
  return isAuthenticated ? (
    <AnalyticProfileProvider>
      <NotebooksProvider>
        <PodcastsProvider>
          <Outlet/>
        </PodcastsProvider>
      </NotebooksProvider>
    </AnalyticProfileProvider>
  ) : (
    <LoginComponent/>
  );
};

export default App;
